import { IIcd10Code } from '~/services/api/icd10Codes/types';
import { IDiagnosisFormValues } from './types';

export const emptyDiagnosisRow = {
  name: '',
  description: '',
};

const getInitialValues = (diagnosis: IIcd10Code | null): IDiagnosisFormValues => ({
  icd10Codes: [
    diagnosis
      ? {
          id: diagnosis.id,
          name: diagnosis.name,
          description: diagnosis.description,
        }
      : emptyDiagnosisRow,
  ],
});

export default getInitialValues;
